import RsvpLiteSessionsPage from './rsvp-lite-session';
import EngageRequest from '../../../services/EngageRequest';
import RSVP_CONSTS from '../../../constants';
import { initTranslation, __, STR_KEY } from '../../../services/Translate';

export const fetchData = (accountUuid, contactUuid, eventId) => {
    return EngageRequest.get(`/rsvp/${accountUuid}/${contactUuid}/${eventId}`).then(data => {
        return initTranslation(data.contact.preferred_language).then(() => data);
    });
};

export const fetchSessionsAndTimes = (accountUuid, contactUuid, eventId, sessionId) => {
    return EngageRequest.get(`/rsvp/${accountUuid}/${contactUuid}/${eventId}/session/${sessionId}`);
};

export const extractAttendance = (attendances, sessionTimes) => {
    const sessionTimeIds         = sessionTimes.map(sessionTime => sessionTime.id);
    /* Order attendances by status, to get the active one */
    const sessionTimeAttendances = attendances.filter(attendance => sessionTimeIds.includes(attendance.event_id)).sort((a, b) => b.updated_at - a.updated_at).sort((a, b) => (a.status > b.status) ? 1 : ((b.status > a.status) ? -1 : 0));
    return sessionTimeAttendances.length ? sessionTimeAttendances[0] : null;
};

const state = {
  	name: 'rsvp-lite-manage-session',
  	url: '/rsvp-lite/manage-sessions/:account_uuid/:contact_uuid/:event_id/:session_id?{env}&{session_time_id}',
  	component: RsvpLiteSessionsPage,
    resolve: [
        {
            token: 'data',
            deps: ['$transition$'],
            resolveFn: (trans) => fetchData(trans.params().account_uuid, trans.params().contact_uuid, trans.params().event_id)
        },
        {
            token: 'account',
            deps: ['data'],
            resolveFn: (data) => data.account
        },
        {
            token: 'attendances',
            deps: ['data'],
            resolveFn: (data) => data.attendances
        },
        {
            token: 'data_session_and_times',
            deps: ['$transition$'],
            resolveFn: (trans) =>  fetchSessionsAndTimes(trans.params().account_uuid, trans.params().contact_uuid, trans.params().event_id, trans.params().session_id)
        },
        {
            token: 'session',
            deps: ['data_session_and_times'],
            resolveFn: (data) => data.session
        },
        {
            token: 'sessionTimes',
            deps: ['data_session_and_times'],
            resolveFn: (data) => data.times
        },
        {
            token: 'bookedAttendance',
            deps: ['attendances', 'sessionTimes'],
            resolveFn: extractAttendance
        }
    ]
};

export default state;